window.PXUTheme = window.PXUTheme || {}

window.PXUTheme.jsHeader = {
  init($section) {
    this.stickyInited = false

    // Selectors
    this.element = document.querySelector("#header")
    this.container = $section[0]
    this.menuToggle = this.element.querySelector('.header__menu-toggle')
    this.allMenuButtons = document.querySelectorAll('li.new-header_item > a')
    this.background = document.querySelector('.new-header__background')
    this.menuBackground = document.querySelector('.new-header__menu-background')
    this.menu = document.querySelector('.new-header_main-links')
    this.html = document.querySelector('html')

    // Initialize all required functionality
    this.setupScrollListener()
    this.setupMenuListeners()
    this.watchReturnLinks()
    this.watchMenuToggles()

    document.querySelector('.new-header__menu-close').addEventListener('click', () => {this.hideMenu()});

    // Keydown event to close the menu on Escape
    document.onkeydown = (evt) => {
      if (evt.keyCode === 27 && this.menu.classList.contains('active')) {
        this.hideMenu()
      }
    }

    // Handle Klaviyo form if ID is provided
    if (this.klaviyo_form_id) {
      this.handleKlaviyoForm()
      this.documentDelegate = new domDelegate.Delegate(document.documentElement)

      this.documentDelegate.on(
        'click',
        '[data-mobile-form-trigger]',
        this.openKlaviyoPopup.bind(this)
      )

      window.addEventListener("klaviyoForms", (event) => {
        if (
          event.detail.formId === this.klaviyo_form_id &&
          event.detail.type === "close"
        ) {
          this.checkCookies()
        }
      })
      this.checkCookies()
    }
  },

  // Scroll listener to add/remove 'scrolled' class
  setupScrollListener() {
    let currentScroll = window.scrollY;

    const checkScroll = () => {
      if (window.scrollY > 0) {
        this.element.classList.add('scrolled');
      } else {
        this.element.classList.remove('scrolled');
      }

      if (window.scrollY > currentScroll) {
        this.element.classList.remove('show');
      } else {
        this.element.classList.add('show');
      }

      currentScroll = window.scrollY;
    };
  
    // Run the check immediately on page load
    checkScroll();
  
    // Add the scroll event listener
    document.addEventListener('scroll', checkScroll);
  },

  watchMenuToggles() {
    const menuToggles = document.querySelectorAll('[data-menu-toggle]');
    for(const toggle of menuToggles) {
      toggle.addEventListener('click', () => {
        if(this.menu.classList.contains('active')) {
          this.hideMenu();
        } else {
          this.showMenu();
        }
        if (event.detail.formId === this.klaviyo_form_id && event.detail.type === "submit") {
          console.log("Klaviyo form submitted");
        }
      });
    }
  },

  // Show menu
  showMenu() {
    this.menu.classList.add('active')
    this.menuBackground.classList.add('active')
    this.background.classList.add('active')
    this.html.classList.add('noscroll')
  },

  // Hide menu
  hideMenu() {
    this.menu.classList.remove('active')
    this.menuBackground.classList.remove('active')
    this.background.classList.remove('active')
    this.html.classList.remove('noscroll')
    if(document.querySelector('li.has-children.active')) document.querySelector('li.has-children.active').classList.remove('active');
  },

  watchReturnLinks() {
    const allReturnLinks = document.querySelectorAll('.new-header_return-link');
    for(const link of allReturnLinks) {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const closestParent = event.target.closest('.new-header_item.active');
        const newParent = document.querySelector(`[data-menu-link="${event.target.dataset.menuTarget}"]`);

        closestParent.classList.remove('active');
        newParent.classList.add('active');
      })
    }
  },

  // Setup menu button and background click listeners
  setupMenuListeners() {
    // Background click listener
    this.background.addEventListener('click', (event) => {
      event.preventDefault()
      const activeItem = document.querySelector('li.has-children.active')
      if (activeItem) {
        activeItem.classList.remove('active')
      }
      this.hideMenu()
    })

    // Menu button click listeners
    this.allMenuButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        const target = event.target
        const parent = target.closest('li')

        // If there's an active item, hide its menu
        const activeItem = document.querySelector('li.has-children.active')
        if (activeItem) {
          this.hideMenu()
          activeItem.classList.remove('active')
        }

        // If the clicked button is for a parent item, activate it and show menu
        if (parent && parent.classList.contains('has-children')) {
          event.preventDefault()
          parent.classList.add('active')
          this.showMenu()
        }
      })
    })
  },

  handleKlaviyoForm() {
    const klaviyoOnsiteData = JSON.parse(localStorage.getItem("klaviyoOnsite"))
    const klaviyoFormID = this.klaviyo_form_id

    if (!klaviyoFormID) return

    if (
      klaviyoOnsiteData?.viewedForms?.modal?.disabledForms?.[klaviyoFormID]?.successActionTypes
    ) {
      return
    }

    const mobileHeader = document.querySelector("#mobile-header")

    // Uncomment and modify these lines to customize behavior
    // const burgerIcon = mobileHeader.querySelector(".mobile-header__open-menu")
    // burgerIcon.classList.add("RedDot")

    // const trigger = document.querySelector(".KlaviyoTrigger-container")
    // trigger.classList.add("active")
  },

  openKlaviyoPopup() {
    window._klOnsite = window._klOnsite || []
    window._klOnsite.push(["openForm", this.klaviyo_form_id])
  },

  checkCookies() {
    const klaviyoOnsiteData = JSON.parse(localStorage.getItem("klaviyoOnsite"))
    const klaviyoFormID = this.klaviyo_form_id

    if (
      klaviyoOnsiteData?.viewedForms?.modal?.disabledForms?.[klaviyoFormID]?.successActionTypes
    ) {
      const mobileHeader = document.querySelector("#mobile-header")

      // Uncomment and modify these lines to customize behavior
      // const burgerIcon = mobileHeader.querySelector(".mobile-header__open-menu")
      // burgerIcon.classList.remove("RedDot")

      // const trigger = document.querySelector(".KlaviyoTrigger-container")
      // trigger.classList.remove("active")
    }
  }
}
